import { Linker } from '@/components/content/linker';
import { Key, ReactChild, ReactFragment, ReactPortal } from 'react';
import { HiLink as LinkIcon } from "react-icons/hi";


export const EventVirtualLink = ({links}) => {
  return (
    <div>
      <span className="block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase"><LinkIcon className="inline-block" /> Attend Online</span>

      <ul className='flex flex-col space-y-2'>
        {links?.map((link: { _key: Key; url: string; title: boolean | ReactChild | ReactFragment | ReactPortal; }) => <li key={link._key}><Linker url={link?.url} classes='hover:underline'>{link?.title}</Linker></li>)}
      </ul>

    </div>
  );
};
